import { FormError } from "models/form"
import { useId } from "@reach/auto-id"

export type ErrorsProps = {
	id: string
	errors: Pick<FormError, "message">[]
}

export const Errors: React.FC<ErrorsProps> = ({ id, errors }) => {
	const prefix = useId()
	const inputId = id ?? `${prefix}-error`

	if (!errors) return <></>

	return (
		<div id={inputId} role="alert" aria-live="polite">
			{errors.map((error, index) => {
				return (
					<p key={index} className="text-xxs text-danger">
						{error.message}
					</p>
				)
			})}
		</div>
	)
}
